import { render, staticRenderFns } from "./NoneData.vue?vue&type=template&id=1b93d90f&scoped=true&"
import script from "./NoneData.vue?vue&type=script&lang=js&"
export * from "./NoneData.vue?vue&type=script&lang=js&"
import style0 from "./NoneData.vue?vue&type=style&index=0&id=1b93d90f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93d90f",
  null
  
)

export default component.exports